import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../../WebComponent.js'
import Navigation from '../../Navigation/Navigation.js'
import AuthorizationFilter from '../../Authorization/AuthorizationFilter.js'
import Authorization from '../../Authorization/Authorization.js'
import '../../../components/AdminVerticalNavigation/AdminVerticalNavigation.js'

export default class AdminNavigation extends WebComponent {
  constructor() {
    super()
  }

  get translationFile() {
    return './views/Admin/Navigation/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.navigationListener = _ => this.reload()
    document.addEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
    this.render()
  }

  disconnectedCallback() {
    document.removeEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
  }

  getTemplate() {

    const allItems = {
      Admin_Stammdatenpflege: {
        text: this.i18n.translate('admin.navigation.vertical.stammdatenpflege'),
        url: '',
        placeholder: true
      },
      Admin_Parameter: {
        text: this.i18n.translate('admin.navigation.vertical.parameter'),
        url: 'Admin_Parameter',
        submenu: true
      },
      Admin_Ml: {
        text: this.i18n.translate('admin.navigation.vertical.ml'),
        url: 'Admin_Ml',
        submenu: true
      },
      Admin_Tek: {
        text: this.i18n.translate('admin.navigation.vertical.tek'),
        url: 'Admin_Tek',
        submenu: true
      },
      Admin_Gek: {
        text: this.i18n.translate('admin.navigation.vertical.gek'),
        url: 'Admin_Gek',
        submenu: true
      },
      Admin_Angebot_Ego: {
        text: this.i18n.translate('admin.navigation.vertical.angebot.ego'),
        url: 'Admin_Angebot_Ego',
        submenu: true
      },
      Admin_Angebot_Egz: {
        text: this.i18n.translate('admin.navigation.vertical.angebot.egz'),
        url: 'Admin_Angebot_Egz',
        submenu: true
      },
      Admin_Angebot_Gaznat: {
        text: this.i18n.translate('admin.navigation.vertical.angebot.gaznat'),
        url: 'Admin_Angebot_Gaznat',
        submenu: true
      },
      Admin_Angebot_Gvm: {
        text: this.i18n.translate('admin.navigation.vertical.angebot.gvm'),
        url: 'Admin_Angebot_Gvm',
        submenu: true
      },
      Admin_Angebot_Ail: {
        text: this.i18n.translate('admin.navigation.vertical.angebot.ail'),
        url: 'Admin_Angebot_Ail',
        submenu: true
      },
      Admin_Seg: {
        text: this.i18n.translate('admin.navigation.vertical.seg'),
        url: 'Admin_Seg',
        submenu: true
      },
      Admin_Monitoring: {
        text: this.i18n.translate('admin.navigation.vertical.monitoring'),
        url: 'Admin_Monitoring'
      },
      Admin_Export: {
        text: this.i18n.translate('admin.navigation.vertical.export'),
        url: 'Admin_Export'
      },
      Admin_Audit: {
        text: this.i18n.translate('admin.navigation.vertical.audit'),
        url: 'Admin_Audit'
      }
    }
    const items = getNavigationHash() === Authorization.VIEWS().notAuthorized ? null : AuthorizationFilter.viewsAllowed(Object.keys(allItems)).map(key => allItems[key])
    if (items === null) {
      return html``
    }

    return html`
      <gasmonitoring-admin-vertical-navigation
        .items="${items}">
      </gasmonitoring-admin-vertical-navigation>
    `
  }
}
customElements.define('gasmonitoring-frontend-admin-navigation', AdminNavigation)
